// config
import CONFIG from '../config';

export default function getWebTabTitle(screenTitle?: string): string {

    return (screenTitle ? `${screenTitle} - ` : '') + CONFIG.WEB_TAB_TITLE_SUFFIX;
}
